import { LatitudeLongitude } from '@aloft/toolkit-shared';

export const createCircleCoordinates = (
  coords: LatitudeLongitude,
  radiusInMeters: number,
  points = 10,
) => {
  if (!points) points = 64;

  const radiusInKm = radiusInMeters / 1000; // Convert meters to kilometers
  const km = radiusInKm;

  const ret: number[][] = [];
  const distanceX = km / (111.32 * Math.cos((coords.latitude * Math.PI) / 180));
  const distanceY = km / 110.574;

  let theta;
  let x;
  let y;
  for (let i = 0; i < points; i++) {
    theta = (i / points) * (2 * Math.PI);
    x = distanceX * Math.cos(theta);
    y = distanceY * Math.sin(theta);

    ret.push([coords.longitude + x, coords.latitude + y]);
  }
  ret.push(ret[0] as number[]);

  return ret;
};
